import revalidator from 'revalidator';

const signInRequestSchema = {
  type: 'object',
  properties: {
    email: {
      type: 'string',
      format: 'email',
      required: 'true',
      messages: {
        format: 'Email does not match the format',
        required: 'Email field is required'
      }
    },
    password: {
      type: 'string',
      pattern: '^.+$',
      required: 'true',
      messages: {
        pattern: 'Password cannot be empty.',
        required: 'Password field is required'
      }
    }
  }
};

export function validateSignInRequest(signInRequest) {
  return revalidator.validate(signInRequest, signInRequestSchema);
}



// WEBPACK FOOTER //
// ./src/tools/validation/auth/sign-in-request-validation.js